"use strict";
module.exports = entity => {
    const ensuredEntity = {
        ...entity,
    };
    if (process.env.PRODUCTION === true || process.env.PRODUCTION === 'true') {
        ensuredEntity.isProductionToken = true;
    }
    else {
        ensuredEntity.isProductionToken = false;
    }
    return ensuredEntity;
};
